import { useState, useRef, useEffect } from "react";
import {
  useLoaderData,
  useFetcher,
  useOutletContext,
  Outlet,
  useParams,
  useSearchParams,
  Link,
  useTransition,
  useLocation,
} from "@remix-run/react";

import {
  AdjustmentsHorizontalIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import * as yup from "yup";
import { ValidatedForm } from "remix-validated-form";
import { withYup } from "@remix-validated-form/with-yup";
import { json } from "@remix-run/node";
import {
  classNames,
  GetSearchBody,
  reorder,
  // getDefaultFormData,
  sortFilterData,
  getURLsearchParamsFromState,
} from "~/utils";
import apiClient from "~/api/axios.server";
import { useInView } from "react-intersection-observer";
// import { getWeiterFilterData, getFilterData, getTags, getAuthers } from "~/api";
import { SearchBox } from "~/shared";
import { Breadcrumb } from "~/screens";
import { Slideover } from "~/components";
import { ErrorBoundaryLayoutComponent, Spinner, Tabs, Modal } from "~/shared";
import theme from "~/theme/default";
import { WeiterFilter, MainFilter } from "~/screens";
import type { ISearchResponse } from "~/types";

import type { currentTabProp } from "~/shared";
import type {
  ResultLIStItem,
  StateFieldsValue,
} from "~/screens/search_filter/types";
import { GetScreenSize } from "~/utils";
import { useMatchesData } from "~/useMatchesData";

const validator = withYup(
  yup.object({
    curriculumIds: yup.array().nullable(),
    secondaryEducationIds: yup.array().nullable(),
    academicYearIds: yup.array().nullable(),
    subjectAreaIds: yup.array().nullable(),
    mediaKindIds: yup.array().nullable(),
    subjectIds: yup.array().nullable(),
    extentIds: yup.array().nullable(),
    licenseIds: yup.array().nullable(),
    mediaCompetenceIds: yup.array().nullable(),
    educationalApplicationAreaIds: yup.array().nullable(),
    specialIds: yup.array().nullable(),
    // levelIds: yup.array().nullable(),
    authorIds: yup.array().nullable(),
    tagIds: yup.array().nullable(),
    q: yup.array().nullable(),
    sort: yup.array().nullable(),
    inclusions: yup.array().nullable(),
  })
);
// const weiterFilterValidator = withYup(
//   yup.object({
//     mediaKindIds: yup.array().nullable(),
//     subjectIds: yup.array().nullable(),
//     extentIds: yup.array().nullable(),
//     licenseIds: yup.array().nullable(),
//     mediaCompetenceIds: yup.array().nullable(),
//     specialIds: yup.array().nullable(),
//     levelIds: yup.array().nullable(),
//     authorIds: yup.array().nullable(),
//     tagIds: yup.array().nullable(),
//   })
// );
const tabs = [
  {
    name: "Medien",
    status: "default",
    id: 1,
  },
  // { name: "Fachartikel", status: "inprogress", id: 0 },

  // { name: "Fortbildungen", status: "inprogress", id: 2 },
];

export const loader = async ({ request, params }: any) => {
  if (params.articleId) {
    return {};
  }
  const url = new URL(request.url);
  const cliend = apiClient();
  let sortQuery = url.searchParams.get("sort");
  let sort = sortQuery === "desc" ? "desc" : "asc";
  const page = url.searchParams.get("page") || 1;

  const searchBody = GetSearchBody(request);

  try {
    const { data } = await cliend.get<ISearchResponse>(
      //@ts-ignore
      `/media?page=${page}&per_page=${40}&sort=${sort}`,
      {
        data: searchBody,
      }
    );

    // const secSpent = (Date.now() - start) / 1000;
    // console.log("============response time", data.metadata, searchBody);
    const {
      curriculumIds,
      secondaryEducationIds,
      academicYearIds,
      learningUnitIds,
      subjectAreaIds,
      q,
      ...withoutMainFilterData
    } = data.metadata.searchAttributes;
    const {
      mediaKindIds,
      educationalApplicationAreaIds,
      mediaCompetenceIds,
      // levelIds,
      restrictionPresenceIds,
      thematicFocusIds,
      inclusionIds,
      extentIds,
      specialIds,
      licenseIds,
      authorIds,
      tagIds,
      subjectIds,
      q: query,
      ...withoutWeiterFilterData
    } = data.metadata.searchAttributes;
    const weiterFilterCount = Object.values(withoutMainFilterData).flat(1);
    const mainFilterCount = Object.values(withoutWeiterFilterData).flat(1);

    return json(
      {
        resultList: data?.media,
        // .sort((a, b) => {
        //   //@ts-ignore
        //   if (new Date(a.createdAt) < new Date(b.createdAt)) {
        //     // console.log("iddddd", a.id);
        //     return 1;
        //   }
        //   return -1;
        // })
        currentPage: data?.metadata.currentPage,
        totalPages: data?.metadata.totalPages,
        searchToken: data?.metadata.searchToken,
        totalEntries: data?.metadata.totalEntries,
        perPage: data?.metadata.perPage,
        searchAttributes: data?.metadata.searchAttributes,
        weiterFilterCount: weiterFilterCount.length,
        mainFilterCount: mainFilterCount.length,
        // defaultValuesMainForm,
        sort: sort,
        hasNextPage: data?.metadata.currentPage < data?.metadata.totalPages,
      },
      {
        headers: {
          // max-age controls the browser cache
          // s-maxage controls a CDN cache
          "Cache-Control": "public, max-age=30, s-maxage=86400",
        },
      }
    );
  } catch (error: any) {
    // console.log("====ererer", error);
    throw new Error(String(error.message));
  }
};

export const ErrorBoundary = ({ error }: any) => {
  return <ErrorBoundaryLayoutComponent error={error} />;
};

export default function Main() {
  const location = useLocation();
  const matchdata = useMatchesData("/", location.pathname);
  const [searchParams] = useSearchParams();
  const authors = matchdata?.authors;
  const tagsList = matchdata?.tagsList;
  const mainFilterData = matchdata?.mainFilterData;
  const filterData = matchdata?.filterData;
  const weiterFilterData = sortFilterData(filterData);
  const defaultValuesMainForm = matchdata?.defaultValuesMainForm;

  //STATE
  const {
    resultList,
    currentPage,
    totalPages,
    totalEntries,
    perPage,
    searchToken,
    weiterFilterCount,
    searchAttributes,
    mainFilterCount,
    sort,
    hasNextPage,
    //  defaultValuesMainForm,
  } = useLoaderData<ResultLIStItem>();

  const [weiterFilterOpen, setWeiterFilter] = useState(false);

  const [MainFilteropen, setMainFilteropen] = useState(
    false || searchParams.get("openmoldal") === "1"
  );
  //@ts-ignore
  const [items, setItems] = useState<ResultLIStItem>({});

  const [current, setCurrent] = useState<currentTabProp>({
    status: "unassigned",
    id: 1,
  });
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const [query, setSearchQuery] = useState(
    searchParams && searchParams.getAll("q").length
      ? searchParams.getAll("q")[0]
      : ""
  );
  const [fieldValue, setFieldValue] = useState<StateFieldsValue>(
    defaultValuesMainForm
  );

  //HOOKS
  const { articleId } = useParams();
  const transition = useTransition();
  const fetcher = useFetcher();
  const size = GetScreenSize();

  const isFetchingNextPage =
    fetcher.state === "loading" && resultList?.length > 39;
  const { showPendingSpinner } =
    useOutletContext<{ showPendingSpinner: boolean }>();

  //REFS
  const page = useRef(1);
  const formRef = useRef(null);
  const { button } = theme;
  const { base, navBar, color } = button;

  const { url } = getURLsearchParamsFromState({
    fieldValue,
    query,
    currentPage,
  });

  const formAction = `/search/main?${url}`;
  // console.log("url=fieldValuefieldValue====", fieldValue);
  const isStateItemshasNextPage = items?.currentPage < items?.totalPages;
  const isSearchedOrFilteredResultHasNexxtPage = currentPage < totalPages;

  const { ref, entry } = useInView({
    // root: scrollArea,
    // target: loadMoreButtonRef,
    onChange: (inView, entery) => {
      // ugly but neccessary :), the next line to make sure that we don't call the loader to fetch at page when  reach end.
      if (
        !inView ||
        (fetcher && isFetchingNextPage && articleId) ||
        !isSearchedOrFilteredResultHasNexxtPage ||
        !isStateItemshasNextPage
      ) {
        return;
      }

      fetchNextPage(entery);
    },
    threshold: 0,
  });

  // we add && resultList.length > 39 to make sure the page does't fetch whenever the coming data is smaller that 40
  const isIntersecting = entry?.isIntersecting && resultList?.length > 39;

  const [sortedData] = reorder({
    stateData: items?.resultList,
    serverData: resultList,
    mainFilterCount,
    weiterFilterCount,
    hasMore: isStateItemshasNextPage,
    transitionState: transition.state,
    size,
    query,
  });

  useEffect(() => {
    // set state if the user change the filter values
    const handleSetData = () => {
      setItems({
        resultList,
        currentPage,
        totalPages,
        totalEntries,
        perPage,
        searchToken,
        weiterFilterCount,
        searchAttributes,
        mainFilterCount,
        defaultValuesMainForm,
        sort,
        hasNextPage,
      });
    };
    if (resultList?.length > 39 && totalEntries !== items?.totalEntries) {
      handleSetData();
    }
  }, [
    currentPage,
    defaultValuesMainForm,
    isSearchedOrFilteredResultHasNexxtPage,
    items?.totalEntries,
    mainFilterCount,
    perPage,
    resultList,
    searchAttributes,
    searchToken,
    sort,
    totalEntries,
    totalPages,
    weiterFilterCount,
    hasNextPage,
  ]);

  useEffect(() => {
    const handleSetData = () => {
      setItems(
        ({
          resultList: stateResult,
          // totalEntries,
          // totalPages,
          // perPage,
          // searchToken,
          weiterFilterCount,
          searchAttributes,
          mainFilterCount,
          defaultValuesMainForm,
          sort,
        }) => {
          // let sortedData = reorder(fetcher.data.resultList, "large");
          return {
            // in the next line we remove dublicated items from state because of the case:
            // where we have data in state and then we have more that 40 items in filter results and we need to get this data in the infite
            resultList: [...stateResult, ...fetcher?.data?.resultList],
            currentPage: fetcher?.data?.currentPage,
            totalEntries: fetcher?.data?.totalEntries,
            totalPages: fetcher?.data?.totalPages,
            perPage: fetcher?.data?.perPage,
            searchToken: fetcher?.data?.searchToken,
            weiterFilterCount,
            searchAttributes,
            mainFilterCount,
            defaultValuesMainForm,
            sort,
            hasNextPage: fetcher?.data?.currentPage < fetcher?.data?.totalPages,
          };
        }
      );
    };
    if (
      fetcher?.data &&
      isIntersecting &&
      fetcher?.data?.currentPage === page?.current
    ) {
      handleSetData();
    }
  }, [isIntersecting, fetcher?.data, hasNextPage]);

  useEffect(() => {
    if (transition.state === "loading") {
      // console.log("reset page", page);
      // reset current page after closing the filters modals
      page.current = 1;
      setWeiterFilter(false);
      setMainFilteropen(false);
    }
  }, [transition.state]);

  useEffect(() => {
    if (transition.state === "submitting") {
      // console.log("reset page", page);
      // reset current page after closing the filters modals
      page.current = 1;
      setMainFilteropen(false);
      setWeiterFilter(false);
    }
  }, [transition.state]);

  const fetchNextPage = (entery: any) => {
    if (entery.isIntersecting) {
      fetcher.load(`/search/main?${url}&page=${(page.current += 1)}`);
    }
  };
  const dataui = {
    data: sortedData,
    showPendingSpinner,
    isFetchingNextPage,
    isStateItemshasNextPage,
  };

  const handleSetSearchFieldValue = (
    e: any,
    fieldValue: { name: string; id: number }
  ) => {
    const { name, checked, id } = e.target;

    setFieldValue((prev: any) => {
      // idKeyValue is removing the unique opart of id and keeping just subjectAreaIds,because the id need to be uniqe for the html form input
      // in the main_filter page id={`subjectAreaIds-${subjectArea.id}`}
      let idKeyValue = id.includes("subjectAreaIds") ? id.split("-")[0] : id;
      let selectedValues = prev[idKeyValue] ? prev[idKeyValue] : [];

      // console.log("selectedValues567684", selectedValues, prev);
      if (checked) {
        let prevState = {
          ...prev,
          //id here present the value of select box
          [idKeyValue]: [
            ...selectedValues,
            {
              value: fieldValue.id,
              checked: checked,
              name: name,
              id: fieldValue.id,
              title: fieldValue.name,
            },
          ],
        };
        return prevState;
      } else {
        let itemWIthOutCheckedITem = prev[idKeyValue].filter((item: any) =>
          item ? item.id !== fieldValue.id : []
        );

        let prevState = {
          ...prev,
          //id here present the value of select box
          [idKeyValue]: [
            ...itemWIthOutCheckedITem,
            // { value: fieldValue, checked: checked, name: name, id: fieldValue },
          ],
        };

        return prevState;
      }
    });
    // }
  };

  const handleResetFilters = (filterName: "weiterFilter" | "main") => {
    const mainFilterValues = [
      "secondaryEducationIds",
      "curriculumIds",
      "academicYearIds",
      "subjectAreaIds",
    ];
    setFieldValue((prev: StateFieldsValue) => {
      let newState = { ...prev };
      for (const key in newState) {
        if (filterName === "main" && mainFilterValues.includes(key)) {
          delete newState[key];
        }
        if (filterName === "weiterFilter" && !mainFilterValues.includes(key)) {
          delete newState[key];
        }
      }
      // console.log("newState from reset func", newState);
      return newState;
    });
    // setMainFilteropen(false);
  };

  return (
    <ValidatedForm
      formRef={formRef}
      // onSubmit={(data, e) => handleSubmit(data, e)}
      // onSubmitCapture={handleSubmit}
      // subaction={formAction}
      // action={formAction}
      //  name="main_filter"
      // id="main_filter_form"
      className="pb-10"
      validator={validator}
      method="get"
      defaultValues={defaultValuesMainForm}
    >
      <div id="main_filter">
        <div className="section-wrapper">
          {!articleId ? (
            <div>
              <div className="mt-4 md:pb-4 md:pt-4">
                <Tabs
                  tabs={tabs}
                  onSelect={setCurrent}
                  current={current.id}
                  counter={0}
                />
              </div>

              <SearchBox
                formAction={formAction}
                // defaultValue={defaultValuesMainForm.q}
                query={query}
                setSearchQuery={setSearchQuery}
                isLandingPage={false}
              />

              <div className="flex w-full flex-col justify-between lg:mt-4 lg:flex-row lg:items-center">
                <div className="order-last mt-4 flex md:mt-0 lg:order-first lg:block lg:border-0">
                  <span className="ml-2 font-bold text-textColor-light md:ml-0">
                    {totalEntries} Medien
                  </span>
                </div>

                <div className="flex w-full flex-row md:w-auto md:justify-end">
                  <button
                    type="button"
                    onClick={() => setMainFilteropen(!MainFilteropen)}
                    className={classNames(
                      "group relative flex w-full px-5 text-xs font-normal text-primary",
                      base,
                      navBar
                    )}
                  >
                    {" "}
                    <AdjustmentsHorizontalIcon
                      className={classNames(
                        "-ml-0.5 mr-2 h-3 w-3 group-hover:text-gray-500 md:h-5 md:w-5"
                      )}
                      aria-hidden="true"
                    />
                    <span>Lehrplanfilter</span>
                    {/* <span className="ml-2 -mr-1 h-4 w-6 rounded-xl bg-btnColor-secondary text-white"> */}
                    {mainFilterCount > 0 && (
                      <span className="absolute top-0 right-0 block h-3 w-3 rounded-full bg-red-400 ring-2 ring-white" />
                    )}
                    {/* </span> */}
                  </button>
                  {/* mobile btn */}

                  <button
                    type="button"
                    onClick={() => setWeiterFilter(!weiterFilterOpen)}
                    className={classNames(
                      "group relative w-full px-5 text-xs font-normal text-primary lg:my-0 lg:ml-3",
                      base,
                      navBar
                    )}
                  >
                    <span>Weitere Filter</span>
                    {/* <span className="-mr-1 ml-2 h-4 w-6 rounded-xl bg-btnColor-secondary text-white"> */}

                    {weiterFilterCount > 0 && (
                      <span className="absolute top-0 right-0 block h-3 w-3 rounded-full bg-red-400 ring-2 ring-white" />
                    )}
                    {/* </span> */}
                  </button>
                  {/* <div>
                    <label
                      htmlFor="sort"
                      className="hidden text-sm font-medium text-gray-700"
                    >
                      Sort result
                    </label>
                    <select
                      onChange={handleSubmitFormOnchange}
                      id="sort"
                      name="sort"
                      className={classNames(
                        "mb-4 w-44 whitespace-nowrap text-center text-xs text-primary lg:mb-0 lg:w-auto",
                        base,
                        navBar
                      )}
                      defaultValue={sort}
                    >
                      <option value="asc">Neueste zuerst</option>
                      <option value="desc">Älteste zuerst</option>
                    </select>
                  </div> */}

                  <Slideover
                    open={weiterFilterOpen}
                    toggle={setWeiterFilter}
                    size={size}
                  >
                    <div className="opacity-1 flex h-full w-full flex-col divide-y divide-gray-200 rounded-r-3xl bg-white pt-2 shadow-xl blur-none">
                      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
                        <div className="px-4 sm:px-6">
                          <div className="flex items-start justify-between">
                            <div className="text-lg font-bold text-gray-900">
                              Medien filtern
                            </div>
                            <div className="ml-3 flex h-7 items-center">
                              <button
                                type="button"
                                className="rounded-full bg-primary text-white focus:outline-none focus:ring-2 focus:ring-btnColor-secondary"
                                onClick={() => setWeiterFilter(false)}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon
                                  className="h-6 w-6"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="relative mt-6 flex-1 px-4 sm:px-6">
                          <WeiterFilter
                            setFieldValue={handleSetSearchFieldValue}
                            fieldsValue={fieldValue}
                            tagsList={tagsList}
                            authorList={authors}
                            //@ts-ignore
                            filterData={weiterFilterData}
                          />
                        </div>
                      </div>
                      <div className="flex justify-between px-4 py-4">
                        <button
                          type="button"
                          onClick={() => handleResetFilters("weiterFilter")}
                          // replace
                          // to={`${pathname}?pag=${1}`}
                          className={classNames(
                            base,
                            "rounded-none border-b border-b-textColor-primary pb-1 text-sm hover:border-b-btnColor-secondary"
                          )}
                        >
                          Alle Filter löschen
                        </button>
                        {/* <MySubmitButton name="filterForm" label="Submit" /> */}
                        <Link
                          to={formAction}
                          className={classNames(
                            "px-6 text-base font-bold text-white",
                            base,
                            color.secondary
                          )}
                          // onClick={() => setWeiterFilter(false)}
                        >
                          Speichern
                        </Link>
                      </div>
                    </div>
                  </Slideover>
                </div>
              </div>
            </div>
          ) : (
            <div className="mt-5">
              {" "}
              <Breadcrumb />
            </div>
          )}
        </div>

        <Modal
          open={MainFilteropen}
          // planDialgo
          setOpen={setMainFilteropen}
          title="Medien nach Lehrplänen finden"
        >
          <MainFilter
            mobileFiltersOpen={mobileFiltersOpen}
            setMobileFiltersOpen={setMobileFiltersOpen}
            action={formAction}
            setOpen={setMainFilteropen}
            fieldsValue={fieldValue}
            setFieldValue={handleSetSearchFieldValue}
            filterData={mainFilterData}
            handleResetMainFilter={handleResetFilters}
          />
        </Modal>

        <Outlet context={dataui} />

        <div className="mt-2 mb-2 flex w-full justify-center p-3">
          <button
            className="whitespace-nowrap text-right text-sm text-gray-700"
            //@ts-ignore
            ref={ref}
            // onClick={() => fetchNextPage()}
            disabled={!isStateItemshasNextPage || isFetchingNextPage}
          >
            {isFetchingNextPage && !articleId ? <Spinner /> : null}
          </button>
        </div>
      </div>
    </ValidatedForm>
  );
}
